module.exports = __webpack_public_path__ + "static/media/Simple-Line-Icons.78f07e2c.woff";